import { takeLatest, put, select } from 'redux-saga/effects';
import { createAxios, logNative } from '../utils/utils';
import {
  SPECIAL_COLLECT_SET_72,
  SPECIAL_COLLECT_CANCEL_72,
  SOFT_COLLECT_LIST_72,
  SPECIAL_COLLECT_LIST_72,
} from '../config';
import {
  GET_SOFT_COLLECT_LIST,
  SET_SOFT_COLLECT_LIST,
  SET_COLLECT_LOADING,
  ADD_COLLECT_SPECIAL_SOFT,
  DELETE_COLLECT_SPECIAL_SOFT,
  SET_SPECIAL_COLLECT_LIST,
  GET_SPECIAL_COLLECT_LIST,
  UPDATE_SPECIAL_COLLECT_LIST,
  UPDATE_SOFT_COLLECT_LIST,
} from '../constants/collection';
import Toast from '../components/Toast/Toast';
import { GET_SPECIAL_INFO_SUCCESS } from '../constants/special';
import { APP_DETAILS_SUCCESS } from '../constants/detail';
import { ANDROID_APP_DETAILS_SUCCESS } from '../constants/adetail';
import React from 'react';
import styles from '../pages/Collection/Collection.module.less';

// 获取软件收藏列表
function* fetchSoftCollectList({ payload }) {
  yield put({ type: SET_COLLECT_LOADING, payload: true });
  const axios = yield createAxios('isNeedUser');
  const res = yield axios.get(SOFT_COLLECT_LIST_72, {
    params: payload,
  });
  try {
    if (res && res.data && (res.data.status === 0 || res.data.status === 200500)) {
      yield put({
        type: SET_SOFT_COLLECT_LIST,
        payload: {
          list: res.data.data || [],
          code: res.data.status,
          error: false,
          ...payload,
        },
      });
    } else {
      yield put({
        type: SET_SOFT_COLLECT_LIST,
        payload: {
          error: true,
          ...payload,
        },
      });
    }
  } finally {
    yield put({ type: SET_COLLECT_LOADING, payload: false });
  }
}

export function* watchFetchSoftCollectList() {
  yield takeLatest(GET_SOFT_COLLECT_LIST, fetchSoftCollectList);
}
// 获取专题收藏列表
function* fetchSpecialCollectList({ payload }) {
  yield put({ type: SET_COLLECT_LOADING, payload: true });
  const axios = yield createAxios('isNeedUser');
  const res = yield axios.get(SPECIAL_COLLECT_LIST_72, {
    params: payload,
  });
  try {
    if (res && res.data && (res.data.status === 0 || res.data.status === 200500)) {
      yield put({
        type: SET_SPECIAL_COLLECT_LIST,
        payload: {
          list: res.data.data || [],
          code: res.data.status,
          error: false,
          ...payload,
        },
      });
    } else {
      yield put({
        type: SET_SPECIAL_COLLECT_LIST,
        payload: {
          error: true,
          ...payload,
        },
      });
    }
  } finally {
    yield put({ type: SET_COLLECT_LOADING, payload: false });
  }
}

export function* watchFetchSpecialCollectList() {
  yield takeLatest(GET_SPECIAL_COLLECT_LIST, fetchSpecialCollectList);
}

function* fetchAddCollectSpecialorSoft({ payload }) {
  const { targetType } = payload;
  const specialInfo = yield select(state => state.special.specialInfo);
  const pcAppInfo = yield select(state => state.detail.appDetails);
  const anAppInfo = yield select(state => state.adetail.appDetails);
  const axios = yield createAxios('isNeedUser');
  const res = yield axios.get(SPECIAL_COLLECT_SET_72, {
    params: payload,
  });

  try {
    if (res && res.data && res.data.status === 0) {
      Toast.success({
        content: <div>收藏成功!</div>,
      });
      // 专题
      if (targetType === 'zt') {
        yield put({
          type: GET_SPECIAL_INFO_SUCCESS,
          payload: {
            ...specialInfo,
            hasCollect: 1,
            collectCount: ((specialInfo && specialInfo.collectCount) || 0) + 1,
          },
        });
      }
      // pc软件
      if (targetType === 'pc') {
        yield put({
          type: APP_DETAILS_SUCCESS,
          payload: {
            ...pcAppInfo,
            hasCollect: 1,
          },
        });
      }
      // pc软件
      if (targetType === 'android') {
        yield put({
          type: ANDROID_APP_DETAILS_SUCCESS,
          payload: {
            ...anAppInfo,
            hasCollect: 1,
          },
        });
      }
    } else {
      Toast.error({
        content: '收藏失败!',
      });
    }
  } catch (err) {
    logNative(err);
  }
}

export function* watchFetchAddCollectSpecialorSoft() {
  yield takeLatest(ADD_COLLECT_SPECIAL_SOFT, fetchAddCollectSpecialorSoft);
}
function* fetchDeleteCollectSpecialorSoft({ payload = {} }) {
  const specialInfo = yield select(state => state.special.specialInfo);
  const pcAppInfo = yield select(state => state.detail.appDetails);
  const anAppInfo = yield select(state => state.adetail.appDetails);
  const axios = yield createAxios('isNeedUser');
  const res = yield axios.get(SPECIAL_COLLECT_CANCEL_72, {
    params: payload,
  });
  try {
    if (res && res.data && res.data.status === 0) {
      // 不是列表页面toast提示
      if (payload.source !== 'list') {
        Toast.success({
          content: <div className={styles.toast}>取消收藏成功!</div>,
          className: styles.toast_img,
        });
      }
      // 专题详情信息
      if (payload.targetType === 'zt' && specialInfo && specialInfo.ztId === payload.targetId) {
        yield put({
          type: GET_SPECIAL_INFO_SUCCESS,
          payload: {
            ...specialInfo,
            hasCollect: 0,
            collectCount: (specialInfo && specialInfo.collectCount) - 1 || 0,
          },
        });
      }
      // 专题收藏列表界面
      if (payload.targetType === 'zt' && payload.source === 'list') {
        yield put({
          type: UPDATE_SPECIAL_COLLECT_LIST,
          payload,
        });
      }
      // pc软件-详情页面
      if (
        payload.targetType === 'pc' &&
        (pcAppInfo.softID || pcAppInfo.softId) === payload.targetId
      ) {
        yield put({
          type: APP_DETAILS_SUCCESS,
          payload: {
            ...pcAppInfo,
            hasCollect: 0,
          },
        });
      }
      // 安卓软件-详情页面
      if (payload.targetType === 'android' && anAppInfo.packageName === payload.targetId) {
        yield put({
          type: ANDROID_APP_DETAILS_SUCCESS,
          payload: {
            ...anAppInfo,
            hasCollect: 0,
          },
        });
      }
      // 软件收藏列表界面
      if (payload.targetType !== 'zt' && payload.source === 'list') {
        yield put({
          type: UPDATE_SOFT_COLLECT_LIST,
          payload,
        });
      }
    } else {
      Toast.error({
        content: <div className={styles.toast}>取消收藏失败!</div>,
        className: styles.toast_img,
      });
    }
  } catch (err) {
    logNative(err);
  }
}

export function* watchFetchDeleteCollectSpecialorSoft() {
  yield takeLatest(DELETE_COLLECT_SPECIAL_SOFT, fetchDeleteCollectSpecialorSoft);
}
